<template>
  <div class="modal-wrapper copy-move-modal">
    <div class="modal">
      <div class="modal-header">
        <h1 v-if="action === 'copy'">Копиране</h1>
        <h1 v-if="action === 'move'">Преместване</h1>
        <span class="sienit modal-close" @click="close(false)">F</span>
      </div>
      <div class="modal-content">
        <datepicker
          :language="bg"
          :inline="true"
          :monday-first="true"
          :minimumView="'day'"
          :maximumView="'day'"
          :full-month-name="true"
          v-model="date"
        ></datepicker>
      </div>
      <div class="modal-footer">
        <button class="btn btn-new" @click="save()">
          <span class="sienit">Y</span>
          Запази
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import Datepicker from "vuejs-datepicker";
import { bg } from "vuejs-datepicker/dist/locale";
export default {
  components: {
    Datepicker: Datepicker
  },
  props: ["action", "id"],
  data() {
    return {
      bg: bg,
      months: [
        "Януари",
        "Февруари",
        "Март",
        "Април",
        "Май",
        "Юни",
        "Юли",
        "Август",
        "Септември",
        "Октомври",
        "Ноември",
        "Декември"
      ],
      date: undefined,
      calendar: {
        date: undefined
      }
    };
  },
  methods: {
    getCalendar() {
      this.$store.dispatch("startLoading");
      let requestUrl = `${process.env.VUE_APP_BASE_URI}/calendar/${this.id}`;
      this.$http
        .get(requestUrl)
        .then(response => {
          this.calendar = response.data;
          this.$store.dispatch("stopLoading");
        })
        .catch(err => {
          console.log(err);
          this.$store.dispatch("stopLoading");
          this.$snotify.error(`Нещо се обърка`);
          this.close(false);
        });
    },
    save() {
      const url = `${
        process.env.VUE_APP_BASE_URI
      }/calendar/exists/${this.date.toISOString()}/${this.calendar.companyId}/${
        this.calendar.projectId
      }/${this.calendar.objectId}`;
      this.$http.get(url).then(response => {
        if (!response.data.length) {
          if (this.action === "move") {
            this.move();
          } else if (this.action === "copy") {
            this.copy();
          }
        } else {
          this.$snotify.error(
            `Този подобект е вече добавен за ${this.date.getDate()} ${
              this.months[this.date.getMonth()]
            } ${this.date.getFullYear()}`
          );
        }
      });
    },
    copy() {
      this.calendar.date = this.date.toISOString();
      delete this.calendar._id;
      this.calendar.isReady = false;
      this.calendar.readyAt = null;
      this.calendar.readyBy = null;
      const url = `${process.env.VUE_APP_BASE_URI}/calendar`;
      this.$http
        .post(url, this.calendar)
        .then(() => {
          this.$snotify.success(
            `Успешно копиран подобект на ${this.date.getDate()} ${
              this.months[this.date.getMonth()]
            } ${this.date.getFullYear()}`
          );
          this.close(true);
        })
        .catch(error => {
          console.log(error);
          this.$snotify.error(`Нещо се обърка`);
        });
    },
    move() {
      this.calendar.date = this.date.toISOString();
      const url = `${process.env.VUE_APP_BASE_URI}/calendar/${
        this.calendar._id
      }`;
      this.$http
        .put(url, this.calendar)
        .then(() => {
          this.$snotify.success(
            `Успешно преместен подобект на ${this.date.getDate()} ${
              this.months[this.date.getMonth()]
            } ${this.date.getFullYear()}`
          );
          this.close(true);
        })
        .catch(error => {
          console.log(error);
          this.$snotify.error(`Нещо се обърка`);
        });
    },
    close(update) {
      this.$parent.$emit("closeCopyMoveCalendarModal", { updated: update });
    }
  },
  mounted() {
    this.getCalendar();
    this.date = new Date();
  }
};
</script>

<style scoped>
.modal {
  width: initial;
}
.modal-header {
  justify-content: flex-start;
  padding: 0 30px;
}
.modal-header h1 {
  color: #fff;
  font-size: 20px;
}
.modal-footer {
  justify-content: center;
}
.btn {
  margin: 0;
}
/* Responsive */
@media screen and (max-width: 1000px) {
  .modal {
    max-height: 80vh;
    width: 90%;
  }
  .modal-header .new-input {
    width: 72%;
  }
}
@media screen and (max-width: 600px) {
  .modal-content-check {
    width: 45%;
  }
  .modal-footer {
    flex-direction: column;
    height: 97px;
  }
  .select-btns {
    margin: 10px 0;
  }
  .btn.btn-new {
    margin: 0 0 10px 0;
  }
}
@media screen and (max-width: 400px) {
  .modal-content-check {
    width: 100%;
  }
}
</style>
